import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import FormContent from "../FormArea/FormContent";
import PushkarFilter from "../PushkarFilter";
import ReportArea from "../ReportArea";


class ModalArea extends Component {
  constructor(props) {
    super(props);
  }


  modalclose = () => {
    let { parentName, st } = this.props.triggerState;
    // console.log(st.modalProps)
    // this.props.liftGlobalState({ name: 'modalProps'},false)
    this.props.liftControlState("modalProps", false)
    let om = this.props.parentState.openmodals;
    let { pageData } = this.props.parentState
    if (pageData.om == undefined) {
      // console.log("hdsdsj")           
      // console.log(pageData)
      let obj = pageData[om]
      pageData[om] = {}
    }
    om.splice(om.length - 1, 1);

    this.props.liftGlobalState({ name: "pageData" }, pageData);
    this.props.liftGlobalState({ name: "openmodals" }, om);
  }

  clearmodal = () => {
    let { parentName, st } = this.props.triggerState;
    let om = this.props.parentState.openmodals;
    let { pageData } = this.props.parentState
    if (pageData.om == undefined) {
      // console.log("hdsdsj")           
      // console.log(pageData)
      let obj = pageData[om]

      pageData[om] = {}
    }
    this.props.liftGlobalState({ name: "pageData" }, pageData);
  }

  // onkeyPress = (e)=>{
  //     console.log(e)
  //     console.log(e.keyCode)
  // }

  savemodal = () => {
    let { parentName, st } = this.props.triggerState;
    this.props.liftControlState("modalProps", false)
    let om = this.props.parentState.openmodals;


    om.splice(om.length - 1, 1);

    this.props.liftGlobalState({ name: "openmodals" }, om);
  }


  render() {
    // This modal will - 
    // Display plain text.
    // Display any single component e.g. text box, text area etc. 
    // Display any page component - e.g. ms13
    let {modalWidth}=this.props.parentState;
    let { st, currentComponent, parentName, handleForceLoad } = this.props.triggerState;

    // debugger;
    let x = this.props.parentState;
    let localParentState = { ...x };
    let modalPageDef;
    if (currentComponent && currentComponent.formmodal) {
      localParentState.localpage = currentComponent.formmodal.pagename;
      localParentState.modalname = currentComponent.name;
      localParentState.currentComponent = currentComponent;
      modalPageDef = this.props.parentState.formElements[currentComponent.formmodal.pagename];
    }

    return (
      <div className="col-12 row">
        <Modal isOpen={st.modalProps} toggle={this.savemodal} backdropTransition={{ timeout: 1300 }} size="lg" style={{ width: modalWidth ? modalWidth : 800, maxWidth: "90%" }}>
          {currentComponent && currentComponent.label ? <ModalHeader toggle={this.savemodal} onKeyDown={this.onkeyPress}>{currentComponent.label}</ModalHeader> : ""}
          <ModalBody>

            {/* if form!=[] then show FormContent */}
            {currentComponent && currentComponent.formmodal && modalPageDef && modalPageDef.form && modalPageDef.form.length > 0 &&
              < FormContent
                parentState={localParentState}
                liftState={this.props.liftState}
                liftGlobalState={this.props.liftGlobalState}
                parentProps={this.props.parentProps}
              />}

            {/* if form==[] then show PushkarFilter and ReportArea */}
            {currentComponent && currentComponent.formmodal && modalPageDef && modalPageDef.filter && modalPageDef.filter.length > 0 &&
              < PushkarFilter
                parentState={localParentState}
                liftState={this.props.liftState}
                liftGlobalState={this.props.liftGlobalState}
                parentProps={this.props.parentProps}
              />
            }
            {currentComponent && currentComponent.formmodal && modalPageDef && modalPageDef.filter && modalPageDef.filter.length > 0 &&
              < ReportArea
                parentState={localParentState}
                liftState={this.props.liftState}
                liftGlobalState={this.props.liftGlobalState}
                parentProps={this.props.parentProps}
                savemodal={this.savemodal}
                handleForceLoad={handleForceLoad}
              />
            }

          </ModalBody>
          {currentComponent && currentComponent.formmodal && modalPageDef && modalPageDef.form && modalPageDef.form.length > 0 &&
            <ModalFooter>
              <Button color="primary" onClick={this.savemodal}>Save</Button>
              <Button color="warning" onClick={this.modalclose}>Clear & Close</Button>
            </ModalFooter>
          }

        </Modal>
      </div>
    );
  }
}

export default ModalArea;